<template>
  <div class="col-xs-12 col-md-12">
    <div class="card p-3 mb-3">
      <div class="card-body">
        <slot name="title" />
        <div class="card-text">
          <slot name="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardDefault'
}
</script>

<style>

</style>
